// src/common/SorterLabel.js
import React, { useState } from 'react';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';

const NoSorting = 0;
const Ascending = 1;
const Descending = -1;

export function SorterLabel({
    id,
    idSorted, // id of the column that is currently sorted
    label,
    onClick, // (id, sortState) => void
    marginLeft=0,
}) {
    const [sortState, setSortState] = useState(NoSorting);

    const onTouch = () => {
        let order;
        if(idSorted !== id) {
            // If this is a new column being sorted, start with Ascending
            order = Ascending;
        }
        else if(sortState === Ascending) {
            order = Descending;
        }
        else if(sortState === Descending) {
            order = NoSorting;
        }
        else {
            order = Ascending;
        }
        setSortState(order);
        if(onClick) {
            onClick(id, order);
        }
    };

    return(
        <span
            style={{
                marginLeft: marginLeft, display: 'inline-flex', alignItems: 'center', cursor: 'pointer'
            }}
            onClick={onTouch}
        >
            {label}{
                idSorted !== id
                ?
                null
                :
                sortState === Ascending
                ?
                <SouthIcon style={{fontSize: '0.8rem', color:'yellow'}} />
                :
                sortState === Descending
                ?
                <NorthIcon style={{fontSize: '0.8rem', color:'yellow'}} />
                :
                null
            }
        </span>
    );
}